import { Route, Switch } from 'react-router-dom';
import AllBannersContainer from '../channels/bannerNotifications/AllBannersContainer';
import TeaseNotificationsComponent from '../channels/teaseNotifications/TeaseNotificationComponent';
import { Suspense, lazy } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Paths = {
  BANNERS: '/banners',
  FLOATING: '/floating',
  TEASE: '/tease',
  SIDEBAR: '/sidebar',
  HUBLESS_BANNERS: '/hubless/banners'
};
const FloatingNotificationsComponent = /*#__PURE__*/lazy(() => import('../channels/floatingNotifications/FloatingNotificationContainer'));
const NotificationSidebarComponent = /*#__PURE__*/lazy(() => import('../channels/sidebarRefactor/SidebarComponent'));
export const Routes = () => {
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: null,
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: [Paths.BANNERS, Paths.HUBLESS_BANNERS],
        exact: true,
        component: AllBannersContainer
      }), /*#__PURE__*/_jsx(Route, {
        path: Paths.FLOATING,
        exact: true,
        component: FloatingNotificationsComponent
      }), /*#__PURE__*/_jsx(Route, {
        path: Paths.TEASE,
        exact: true,
        component: TeaseNotificationsComponent
      }), /*#__PURE__*/_jsx(Route, {
        path: Paths.SIDEBAR,
        exact: true,
        component: NotificationSidebarComponent
      })]
    })
  });
};